/**
 * Model konfiguracji (szablonów i reguł czasowych) dla silnika
 * automatycznych przypomnień o kolejnych wizytach.
 * Pozwala klinice na pełną personalizację treści maili, powiadomień Push
 * oraz harmonogramu wysyłek.
 */
export class NextVisitReminderSettings {

  /** Globalnie unikalny identyfikator konfiguracji. */
  public uuid: string;

  /** Identyfikator użytkownika (administratora), który utworzył lub edytował te ustawienia. */
  public authorUUID: string;

  public created: Date;
  public modified: Date;

  /** Vetcode placówki weterynaryjnej, dla której obowiązują te reguły. */
  public vetcodeId: number;

  /** Treść wiadomości e-mail dla pierwszego przypomnienia. */
  public firstReminderEmailText: string;

  /** Temat wiadomości e-mail dla pierwszego przypomnienia. */
  public firstReminderEmailTitle: string;

  /** Treść powiadomienia Push (aplikacja mobilna) dla pierwszego przypomnienia. */
  public firstReminderPushText: string;

  /** Tytuł powiadomienia Push dla pierwszego przypomnienia. */
  public firstReminderPushTitle: string;

  /** Opóźnienie czasowe (wyrażone w dniach) dla pierwszego przypomnienia.
   */
  public firstReminderDaysDelay: string;


  /** Główny przełącznik (Togggle) aktywujący dwuetapową kampanię przypomnień.
   * Jeśli true, system wyśle kolejną wiadomość, o ile pacjent nie zareagował na pierwszą.
   */
  public sendSecondReminder: boolean;

  /** Treść wiadomości e-mail dla drugiego przypomnienia. */
  public secondReminderEmailText: string;

  /** Temat wiadomości e-mail dla drugiego przypomnienia. */
  public secondReminderEmailTitle: string;

  /** Treść powiadomienia Push dla drugiego przypomnienia. */
  public secondReminderPushText: string;

  /** Tytuł powiadomienia Push dla drugiego przypomnienia. */
  public secondReminderPushTitle: string;

  /** Opóźnienie czasowe (wyrażone w dniach) dla drugiego przypomnienia.
   */
  public secondReminderDaysDelay: string;


  public visitTypeEmailTitle: string;
  public visitTypeEmailText: string;
  public visitTypePushText: string;
  public visitTypePushTitle: string;
  public visitTypeDaysDelay: string;


  public flashReminderEmailTitle: string;
  public flashReminderEmailText: string;
  public flashReminderPushText: string;
  public flashReminderPushTitle: string;

}
